import React from 'react';
import withIcon from '../utilities/withIcon';

const IconCaretUpDown = () => {
  return (
    <g>
      <path d="m13.8884 6.7694c.605 0 .75-.35.3222-.7778l-5.4328-5.4328a1.1033 1.1033 0 0 0 -1.5557 0l-5.4327 5.4328c-.4278.4278-.2828.7778.3222.7778z" />
      <path d="m2.1116 9.2306c-.605 0-.75.35-.3222.7778l5.4328 5.4328a1.1033 1.1033 0 0 0 1.5557 0l5.4328-5.4328c.4278-.4278.2828-.7778-.3222-.7778z" />
    </g>
  );
};

export default withIcon(IconCaretUpDown);
